<template>
  <div class="tab">
    <div class="tabContent">
      <router-view />
    </div>
    <div class="tabbar">
      <div class="tabbar-item" :class="{active: $route.name ==  'home'}" @click="onClickTabItem('home')">
        <svg t="1711080119086" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
          p-id="8446" width="24" height="24">
          <path
            d="M96 480c-9.6 0-19.2-3.2-25.6-12.8-12.8-12.8-9.6-35.2 3.2-44.8L451.2 112c35.2-25.6 86.4-25.6 118.4 0l377.6 307.2c12.8 9.6 16 32 3.2 44.8s-32 16-44.8 3.2L531.2 166.4c-9.6-6.4-28.8-6.4-38.4 0L115.2 473.6c-6.4 6.4-12.8 6.4-19.2 6.4z m720 448H608c-19.2 0-32-12.8-32-32V745.6c0-22.4-38.4-44.8-67.2-44.8s-64 19.2-64 44.8V896c0 19.2-12.8 32-32 32H211.2c-48 0-83.2-35.2-83.2-80V544c0-19.2 12.8-32 32-32s32 12.8 32 32v304c0 9.6 6.4 16 19.2 16H384V745.6c0-64 67.2-108.8 128-108.8s131.2 44.8 131.2 108.8V864h176c9.6 0 16 0 16-19.2V544c0-19.2 12.8-32 32-32s32 12.8 32 32v304c-3.2 48-35.2 80-83.2 80z"
            fill="#858ea9" p-id="8447"></path>
        </svg>
        <div>{{$t("tab.home")}}</div>
      </div>
      <div class="tabbar-item" :class="{active: $route.name ==  'soulMate'}" @click="onClickTabItem('soulMate')" >
        <svg t="1712910126865" class="icon" viewBox="0 0 1042 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13771" width="24" height="24"><path d="M343.771429 875.885714H164.571429V694.857143c0-1.828571-1.828571-1.828571-3.657143-1.828572h-73.142857c-1.828571 0-3.657143 1.828571-3.657143 1.828572v219.428571c0 21.942857 18.285714 38.4 40.228571 38.4h219.428572c1.828571 0 3.657143-1.828571 3.657142-1.828571v-73.142857s-1.828571-1.828571-3.657142-1.828572zM928.914286 71.314286h-219.428572c-1.828571 0-3.657143 1.828571-3.657143 1.828571v73.142857c0 1.828571 1.828571 1.828571 3.657143 1.828572h179.2V329.142857c0 1.828571 1.828571 1.828571 3.657143 1.828572h73.142857c1.828571 0 3.657143-1.828571 3.657143-1.828572V109.714286c0-20.114286-18.285714-38.4-40.228571-38.4zM965.485714 693.028571h-73.142857c-1.828571 0-3.657143 1.828571-3.657143 1.828572v181.028571h-179.2c-1.828571 0-3.657143 1.828571-3.657143 1.828572v73.142857c0 1.828571 1.828571 1.828571 3.657143 1.828571h219.428572c21.942857 0 40.228571-18.285714 40.228571-38.4V694.857143s-1.828571-1.828571-3.657143-1.828572zM87.771429 332.8h73.142857c1.828571 0 3.657143-1.828571 3.657143-1.828571V149.942857h179.2c1.828571 0 3.657143-1.828571 3.657142-1.828571v-73.142857c0-1.828571-1.828571-1.828571-3.657142-1.828572h-219.428572C102.4 73.142857 84.114286 91.428571 84.114286 111.542857v219.428572c1.828571 0 1.828571 1.828571 3.657143 1.828571zM482.742857 290.742857h-104.228571c-1.828571 0-1.828571 0-1.828572 1.828572l-140.8 440.685714v1.828571l1.828572 1.828572h89.6c1.828571 0 1.828571 0 1.828571-1.828572l31.085714-111.542857h137.142858l31.085714 111.542857c0 1.828571 1.828571 1.828571 1.828571 1.828572h93.257143s1.828571 0 1.828572-1.828572v-1.828571L484.571429 292.571429c0-1.828571-1.828571-1.828571-1.828572-1.828572z m-54.857143 74.971429c5.485714 18.285714 9.142857 36.571429 14.628572 54.857143 7.314286 27.428571 14.628571 56.685714 21.942857 84.114285l12.8 43.885715h-96.914286l12.8-43.885715c10.971429-43.885714 23.771429-93.257143 34.742857-138.971428zM766.171429 733.257143V292.571429c0-1.828571-1.828571-1.828571-3.657143-1.828572h-87.771429c-1.828571 0-3.657143 1.828571-3.657143 1.828572v440.685714c0 1.828571 1.828571 1.828571 3.657143 1.828571h87.771429c1.828571 0 3.657143 0 3.657143-1.828571z" p-id="13772" fill="#858ea9"></path></svg>
        <div>AI对话</div>
      </div>
      <div class="tabbar-item" :class="{active: $route.name ==  'dynamic'}" @click="onClickTabItem('dynamic')">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18.9745 10.2051C18.4115 8.18497 17.2852 7.05306 15.7963 6.99759V5.34043C15.7963 4.93604 15.4687 4.6084 15.0643 4.6084C14.6599 4.6084 14.3323 4.93604 14.3323 5.34043V6.99226H9.69608V5.34043C9.69608 4.93604 9.36844 4.6084 8.96405 4.6084C8.55966 4.6084 8.23202 4.93604 8.23202 5.34043V6.99704C6.72591 7.04683 5.65382 8.12511 5.05305 10.1904L2.39706 18.3826C2.37346 18.4555 2.36133 18.5315 2.36133 18.6082C2.36133 20.4962 3.85209 22.032 5.68454 22.032H18.3382C20.1707 22.032 21.6614 20.4962 21.6614 18.6082C21.6614 18.5315 21.6493 18.4555 21.6257 18.3826L18.9745 10.2051ZM18.3382 20.5679H5.68451C4.69346 20.5679 3.88113 19.7463 3.82822 18.7154L6.45228 10.6207C7.01703 8.68079 7.80029 8.45633 8.3405 8.45633H15.6822C16.2706 8.45633 17.0753 8.83021 17.5678 10.6112C17.5707 10.6214 17.5738 10.6317 17.5771 10.6417L20.1945 18.7155C20.1416 19.7463 19.3293 20.5679 18.3382 20.5679Z"
            fill="#858ea9" />
          <path
            d="M9.15488 10.6294C8.75049 10.6294 8.42285 10.957 8.42285 11.3614V12.0756C8.42285 12.48 8.75049 12.8076 9.15488 12.8076C9.55927 12.8076 9.88691 12.48 9.88691 12.0756V11.3614C9.88689 10.957 9.55925 10.6294 9.15488 10.6294Z"
            fill="#858ea9" />
          <path
            d="M14.8678 10.6294C14.4634 10.6294 14.1357 10.957 14.1357 11.3614V12.0756C14.1357 12.48 14.4634 12.8076 14.8678 12.8076C15.2722 12.8076 15.5998 12.48 15.5998 12.0756V11.3614C15.5998 10.957 15.2722 10.6294 14.8678 10.6294Z"
            fill="#858ea9" />
          <path
            d="M13.8111 13.9353C13.4706 13.7173 13.0179 13.8162 12.7998 14.157C12.797 14.1615 12.4863 14.6128 12.0037 14.6128C11.5348 14.6128 11.2431 14.1879 11.2235 14.1586C11.0086 13.821 10.5608 13.7178 10.2199 13.9301C9.87649 14.1434 9.77092 14.5947 9.98444 14.9381C10.2473 15.3611 10.9684 16.0769 12.0037 16.0769C13.0338 16.0769 13.7637 15.3665 14.0328 14.9467C14.2508 14.6064 14.1517 14.1534 13.8111 13.9353Z"
            fill="#858ea9" />
          <path
            d="M22.4332 6.29933C22.3858 6.199 21.2496 3.82898 19.4703 2.84363C18.2991 2.19477 14.1223 2.02319 12.0776 2.02319C9.64771 2.02319 5.63823 2.24171 4.5521 2.84363C2.77256 3.82898 1.63638 6.199 1.58896 6.29933C1.41621 6.66486 1.57229 7.10141 1.93759 7.27417C2.30385 7.44764 2.73968 7.29084 2.91243 6.92554C3.1798 6.36008 4.12318 4.75473 5.2615 4.12419C5.80408 3.82346 8.83442 3.48723 12.0776 3.48723C15.3386 3.48723 18.2169 3.82298 18.7609 4.12419C20.1246 4.87958 21.1004 6.90575 21.1099 6.92626C21.2353 7.19006 21.4979 7.34471 21.7719 7.34471C21.8768 7.34471 21.9833 7.32206 22.0846 7.27417C22.4499 7.10141 22.606 6.66486 22.4332 6.29933Z"
            fill="#858ea9" />
        </svg>
        <div>{{$t("tab.dynamic")}}</div>
      </div>
      <!-- 消息 -->
      <div class="tabbar-item" :class="{ active: $route.name == 'notificationTypeList' }"
        @click="onClickTabItem('notificationTypeList')">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="chat">
            <path id="Union"
              d="M6.95693 15.75H19.5V6H4.5V17.7974L6.95693 15.75ZM3.73808 20.3849C3.44499 20.6292 3 20.4208 3 20.0392V6C3 5.17157 3.67157 4.5 4.5 4.5H19.5C20.3284 4.5 21 5.17157 21 6V15.75C21 16.5784 20.3284 17.25 19.5 17.25H7.5L3.73808 20.3849Z"
              fill="#858ea9" fill-opacity="0.9" />
          </g>
        </svg>
        <div>{{ $t("tab.notification") }}</div>
      </div>
      <div class="tabbar-item" :class="{active: $route.name ==  'personalCenter'}"
        @click="onClickTabItem('personalCenter')">
        <svg t="1711079942892" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
          p-id="7315" width="24" height="24">
          <path
            d="M800 384c0-160-128-288-288-288s-288 128-288 288c0 108.8 57.6 201.6 147.2 249.6-121.6 48-214.4 153.6-240 288-3.2 16 6.4 35.2 25.6 38.4h6.4c16 0 28.8-9.6 32-25.6 28.8-150.4 160-259.2 313.6-262.4h6.4c156.8 0 284.8-128 284.8-288zM288 384c0-124.8 99.2-224 224-224s224 99.2 224 224c0 121.6-99.2 220.8-220.8 224H505.6C384 604.8 288 505.6 288 384zM723.2 675.2c-16-9.6-35.2-6.4-44.8 9.6-9.6 16-6.4 35.2 9.6 44.8 73.6 51.2 124.8 121.6 140.8 204.8 3.2 16 16 25.6 32 25.6h6.4c16-3.2 28.8-19.2 25.6-38.4-19.2-99.2-80-185.6-169.6-246.4z"
            fill="#858ea9" p-id="7316"></path>
        </svg>
        <div>{{$t("tab.my")}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'tab',
    methods: {
      onClickTabItem(name) {
        if (this.$route.name != name) {
          this.$router.replace({
            name: name
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tab {
    height: 100%;

    .tabContent {
      height: calc(100% - 50px);
    }

    .tabbar {
      box-sizing: border-box;
      /* border-top: 1px solid;
      border-color: rgba($color: #000000, $alpha: 0.33); */
      display: flex;
      align-items: center;
      height: 5rem;

      &-item {
        color: #858ea9;
        width: 50%;
        text-align: center;

        &.active {
          color: #3143c4;

          &>svg {
            path {
              fill: #3143c4
            }
          }
        }

        /* & > svg {
        width: 24;
      } */
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/tab/tab.vue